module.exports = __webpack_public_path__ + "img/QRIS-payment.f08471a1.png";